/**
 * 言語に応じてタイトルを返す関数
 */
export const getArtWorkTitle = ({
  artWork,
  artWorkVariantTitle,
  langType,
}: {
  artWork: Pick<ArtWork, 'title' | 'title_en'>
  artWorkVariantTitle?: string | null
  langType: string
}): string | undefined => {
  const title =
    langType === 'en' && artWork?.title_en ? artWork.title_en : artWork?.title

  if (title && artWorkVariantTitle) {
    return `${title} / ${artWorkVariantTitle}`
  }

  if (!title && artWorkVariantTitle) {
    return artWorkVariantTitle
  }

  return title
}
